
/**
 * Hook per verificare che il processo di build funzioni correttamente
 * Questo aiuta a diagnosticare problemi di build e deployment
 */
export const useBuildCheck = () => {
  // Semplice funzione per verificare che l'ambiente di build sia configurato correttamente
  const checkBuildEnvironment = () => {
    console.log('Build environment check initiated');
    console.log('NODE_ENV:', process.env.NODE_ENV);
    console.log('Build timestamp:', new Date().toISOString());
    return process.env.NODE_ENV === 'production' ? 'Production build' : 'Development build';
  };

  return {
    checkBuildEnvironment,
    buildVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
    buildDate: import.meta.env.VITE_BUILD_DATE || new Date().toISOString(),
  };
};
